import React, {useEffect, useState} from 'react';
import Modal from "react-bootstrap/esm/Modal";
import _ from "underscore";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {useDispatch, useSelector} from "react-redux";
import {
    getB2bCollections,
    hideVipModal,
    saveB2bCollection,
    saveFavoriteToB2bCollection
} from "../../../actionCreators/favoritesAC";

const VipModal = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getB2bCollections());
    }, [])

    const [list_name, setListName] = useState('');
    const {show_vip_add_collection_modal, error_message, vip_collections, product_id} = useSelector(state => state.appReducer);

    function handleKeyPress(e) {
        if(e.key === 'Enter'){
            dispatch(saveB2bCollection(list_name));
            toggleVipCollectionModal(false);
        }
    }

    const toggleVipCollectionModal = (show_hide) => {
        dispatch({
            type: 'TOGGLE_VIP_ADD_COLLECTION_MODAL',
            show_hide: show_hide
        })
    }

    return (
        <Modal
            show={true}
            size="md"
            centered
            onHide={() => show_vip_add_collection_modal ? toggleVipCollectionModal(false) : dispatch(hideVipModal())}
            className="vip-modal modal-normal"
            container={document.getElementById('react-header')}
            backdropClassName="dark-overlay overlay-second-modal"
        >
            <Modal.Header>
                <span className="icon-close" onClick={() => show_vip_add_collection_modal ? toggleVipCollectionModal(false) : dispatch(hideVipModal())}></span>
            </Modal.Header>
            <Modal.Body>
                {show_vip_add_collection_modal ?
                    <>
                        <h1 className="modal-normal__title">Save New List</h1>
                        <div className="modal-normal__title-subline"></div>
                        <div className="vip-modal__collections-list">
                            <Form.Group
                                className="vip-modal__add-list--form-group"
                            >
                                <Form.Label
                                    className="vip-modal__add-list--label"
                                >
                                    Name Your List
                                </Form.Label>
                                <Form.Control
                                    autoFocus
                                    type="text"
                                    value={list_name}
                                    placeholder="e.g. Louis Vuitton Handbags"
                                    className={`vip-modal__add-list--input ${error_message && 'vip-modal__add-list--input--error'}`}
                                    onChange={(evt) => setListName(evt.target.value)}
                                    onKeyPress={(e) => handleKeyPress(e)}
                                    maxLength="50"
                                />
                                {error_message &&
                                <span className="icon-error icon-exclamation"/>
                                }
                                <span className="vip-modal__add-list--validation-failed">{error_message}</span>
                            </Form.Group>
                            <Button
                                className="rbg-btn-black vip-modal__add-list--cta"
                                variant="secondary"
                                onClick={() => dispatch(saveB2bCollection(list_name, vip_collections))}
                            >
                                Save New List
                            </Button>
                        </div>
                    </>
                    :
                    <>
                        <h1 className="modal-normal__title">Add To List</h1>
                        <div className="modal-normal__title-subline"></div>
                        <div className="vip-modal__collections-list">
                            <div
                                className="vip-modal__item"
                                onClick={() => toggleVipCollectionModal(true)}
                            >
                                + Create a New List
                            </div>
                            {
                                _.map(vip_collections, (vip_collection, idx) => {
                                    return (
                                        <div
                                            key={idx}
                                            className="vip-modal__item"
                                            onClick={() => product_id ? dispatch(saveFavoriteToB2bCollection(product_id, vip_collection.id)) : dispatch(hideVipModal())}
                                        >
                                            {vip_collection.name}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </>
                }
            </Modal.Body>
        </Modal>
    )
}

export default VipModal;